import { IRBDItem } from "../../../../models/rbd"
import { IDiagramValues } from "../Diagram"
import finder, { SELECTOR } from "../helper/finder"
import { isElement, isSerialTransmission, isParalelTransmission, isRedundantTransmission } from "../helper/validator"
import { handleElement, handleSerial, handleRedundant } from '.'

export function handleParalel(current: IRBDItem, prev: IRBDItem) {
    let result: IDiagramValues[] = []

    current = finder(current, SELECTOR.TRANSMISSION_ELEMENTS)

    if (Array.isArray(current)) {
        current.forEach((i, x) => {
            if (isElement(i)) {
                const element = handleElement(i, prev)
                return result.push(element)
            } else {
                if (isSerialTransmission(i)) {
                    const serial = handleSerial(i, prev)
                    result.push(...serial)
                } else if (isParalelTransmission(i)) {
                    const paralel = handleParalel(i, prev)
                    result.push(...paralel)
                } else if (isRedundantTransmission(i)) {
                    const redundant = handleRedundant(i, prev)
                    result.push(...redundant)
                }
            }
        })
    }

    return result
}